import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Seite nicht gefunden" />
      <section className="mx-auto max-w-3xl px-4 py-32 text-center">
        <p className="text-8xl font-extrabold text-primary/10 uppercase">404</p>
        <h1 className="mt-4 text-3xl font-extrabold uppercase">Seite nicht gefunden</h1>
        <p className="mt-3 text-dark/60">Diese Seite existiert nicht oder wurde verschoben.</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-primary px-8 py-3 font-bold text-white uppercase tracking-wide text-sm hover:bg-accent transition-colors"
        >
          Zurück zur Startseite
          <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </section>
    </>
  );
}
